import type { ReactNode } from 'react';

import { StrongStyle } from './Strong.css';

export const Strong = ({ children }: { children: ReactNode }): JSX.Element => {
  return <strong className={StrongStyle}>{children}</strong>;
};
